module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./shared/portal */ "./src/shared/portal.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./shared/outside_click */ "./src/shared/outside_click.tsx"), exports);


/***/ }),

/***/ "./src/shared/outside_click.tsx":
/*!**************************************!*\
  !*** ./src/shared/outside_click.tsx ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(/*! tslib */ "tslib");
var React = __webpack_require__(/*! react */ "react");
var react_dom_1 = __webpack_require__(/*! react-dom */ "react-dom");
var OutsideClick = /** @class */ (function (_super) {
    tslib_1.__extends(OutsideClick, _super);
    function OutsideClick() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OutsideClick.prototype.componentDidMount = function () {
        var _this = this;
        var node = react_dom_1.findDOMNode(this);
        this.clickHandler = function (event) {
            var target = event.target;
            if (_this.props.disablePreventDefault) {
                event.preventDefault();
                event.stopPropagation();
            }
            // tslint:disable-next-line:no-any
            if (target !== node && !node.contains(target)) {
                _this.props.onOutsideClick();
            }
        };
        window.document.addEventListener('click', this.clickHandler);
    };
    OutsideClick.prototype.componentWillUnmount = function () {
        if (this.clickHandler) {
            window.document.removeEventListener('click', this.clickHandler);
        }
    };
    OutsideClick.prototype.render = function () {
        var args = [
            this.props.rootElement,
            {},
        ].concat(this.props.children);
        return React.cloneElement.apply(null, args);
    };
    OutsideClick.defaultProps = {
        rootElement: React.createElement("div", null),
    };
    return OutsideClick;
}(React.Component));
exports.OutsideClick = OutsideClick;


/***/ }),

/***/ "./src/shared/portal.tsx":
/*!*******************************!*\
  !*** ./src/shared/portal.tsx ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(/*! tslib */ "tslib");
var style_1 = __webpack_require__(/*! @cian/utils/lib/shared/style */ "@cian/utils/lib/shared/style");
var React = __webpack_require__(/*! react */ "react");
var react_dom_1 = __webpack_require__(/*! react-dom */ "react-dom");
var PortalOutsideClick = /** @class */ (function (_super) {
    tslib_1.__extends(PortalOutsideClick, _super);
    function PortalOutsideClick(props) {
        var _this = _super.call(this, props) || this;
        if (!props.rootElement) {
            _this.rootElement = document.body;
        }
        else {
            _this.rootElement = props.rootElement;
        }
        return _this;
    }
    PortalOutsideClick.prototype.componentDidMount = function () {
        if (!this.props.containerElement) {
            this.containerElement = document.createElement('div');
            var attribute = 'data-react-portal-outside-click-container-id';
            var id = "" + (new Date()).getTime();
            this.containerElement.setAttribute(attribute, id);
        }
        else {
            this.containerElement = this.props.containerElement;
        }
        this.rootElement.appendChild(this.containerElement);
        this.renderPortal();
    };
    PortalOutsideClick.prototype.componentWillUnmount = function () {
        if (this.containerElement) {
            react_dom_1.unmountComponentAtNode(this.containerElement);
            this.rootElement.removeChild(this.containerElement);
        }
    };
    PortalOutsideClick.prototype.componentDidUpdate = function () {
        this.renderPortal();
    };
    PortalOutsideClick.prototype.render = function () {
        return (React.createElement("noscript", null));
    };
    PortalOutsideClick.prototype.renderPortal = function () {
        react_dom_1.render(React.createElement("div", tslib_1.__assign({}, style_1.mergeStyles(this.props.portalStyles)), this.props.children), this.containerElement);
    };
    return PortalOutsideClick;
}(React.Component));
exports.PortalOutsideClick = PortalOutsideClick;


/***/ }),

/***/ "@cian/utils/lib/shared/style":
/*!***********************************************!*\
  !*** external "@cian/utils/lib/shared/style" ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@cian/utils/lib/shared/style");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "react-dom":
/*!****************************!*\
  !*** external "react-dom" ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ "tslib":
/*!************************!*\
  !*** external "tslib" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ })

/******/ });
//# sourceMappingURL=frontend-outside-click-component.js.map